<script setup lang="ts">
import { Type } from '@Shared/components/visuals/utility';

interface TopNValuesTileProps {
  title?: string;
  valueType?: Type;
  values?: string[];
  isLoadingIndicator?: boolean;
}

const props = defineProps<TopNValuesTileProps>();
const { title, valueType, values } = toRefs(props);
const backgroundColor = computed(() => {
  if (valueType.value === Type.Negative) {
    return 'bg-#D4002B';
  } else if (valueType.value === Type.Positive) {
    return 'bg-#0C8A65';
  } else {
    return 'bg-#4F4F4F';
  }
});
</script>

<template>
  <div class="flex flex-col">
    <div
      v-if="isLoadingIndicator"
      class="flex flex-col px-4 py-4 bg-white rounded-b min-h-0 flex-grow justify-center items-center"
    >
      <div class="loading-gradient-static h-15 w-40"></div>
    </div>
    <template v-if="!isLoadingIndicator">
      <div :class="backgroundColor" class="flex rounded-t justify-center items-center p-4">
        <div class="flex text-white text-xs font-normal font-family[Roboto] uppercase">
          {{ title }}
        </div>
      </div>
      <div class="flex flex-col gap-2 px-4 py-2 bg-white rounded-b min-h-0 flex-grow overflow-y-auto text-center">
        <div
          v-for="value in values"
          :key="value"
          class="text-#4F4F4F text-3 xl:text-14px line-height-16px xl:line-height-20px font-family[Roboto] vertical-top"
        >
          {{ value }}
        </div>
        <div v-if="values && values.length === 0" class="m-auto text-8 font-family[Roboto]">N/A</div>
      </div>
    </template>
  </div>
</template>
